import { render, staticRenderFns } from "./page.vue?vue&type=template&id=1e69b5c9&scoped=true&"
import script from "./page.vue?vue&type=script&lang=js&"
export * from "./page.vue?vue&type=script&lang=js&"
import style0 from "./page.vue?vue&type=style&index=0&id=1e69b5c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e69b5c9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e69b5c9')) {
      api.createRecord('1e69b5c9', component.options)
    } else {
      api.reload('1e69b5c9', component.options)
    }
    module.hot.accept("./page.vue?vue&type=template&id=1e69b5c9&scoped=true&", function () {
      api.rerender('1e69b5c9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/modules/compose/page.vue"
export default component.exports